import { storeToRefs } from 'pinia';
import { Logger } from '~~/helpers/logger';
import { useCart } from '~/utils/ct';
import { DISCOUNT_FIELDS } from '~~/constants/commerceTools';
import { parseVolumeDiscounts } from '~~/helpers/voumeDiscounts/parseVolumeDiscounts';
import type { VolumeDiscountsGetters, VolumeDiscountsState } from '~~/types/vuex/VolumeDiscounts';
import type { VolumeDiscountConfigurations, DiscountData } from '~~/types/discounts';

import { EXPONDO_MIDDLEWARE_ROUTES } from '~~/constants/routes';
import { volumeDiscountsStore } from '~/stores/volumeDiscounts';

export default () => {

  const { cart } = useCart();
  const { makeCommercetoolsRequest } = useExpondoMiddleware();
  const store = volumeDiscountsStore();
  const { volumeDiscountConfigurations } = storeToRefs<VolumeDiscountsState & VolumeDiscountsGetters>(store);

  const isGroupActive = (groupName: string) => {

    return store.isGroupActive(groupName);
  
  };

  const load = async (discountGroup: string) => {

    if (volumeDiscountConfigurations.value[discountGroup]) {

      return;
    
    }
    try {

      const res = await makeCommercetoolsRequest<DiscountData>({
        endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_VOLUME_DISCOUNTS,
        data: {
          discountGroup,
          sort: [`${DISCOUNT_FIELDS.SORT_ORDER} asc`],
        },
      });
      store.setGroup({
        groupKey: discountGroup,
        value: parseVolumeDiscounts(res?.data?.cartDiscounts?.results),
      });
    
    } catch (err) {

      Logger.error('error.useVolumeDiscount', String(err));
    
    }
  
  };

  const isDiscountCodeActive = computed(() => cart?.value?.discountCodes?.length !== 0);

  const hasNonEmptyArray = (volumeDiscountConfigurations: VolumeDiscountConfigurations): boolean =>
    Object.keys(volumeDiscountConfigurations)
      .some(key => {

        const group = volumeDiscountConfigurations?.[key];

        return Array.isArray(group) && group.length > 0;
      
      });

  const isVolumeDiscountApplicableForCart = computed(() => {

    return hasNonEmptyArray(volumeDiscountConfigurations.value);
  
  });

  const isDiscountConflict = computed(() => {

    return isVolumeDiscountApplicableForCart.value && isDiscountCodeActive.value;
  
  });

  return {
    ...store,
    isGroupActive,
    volumeDiscountConfigurations,
    load,
    isDiscountConflict,
    isDiscountCodeActive,
    isVolumeDiscountApplicableForCart,
  };

};